import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from '../../../../services/mysql.service';

// 
import { Job } from '../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, of} from 'rxjs';
// 
import { Subscription } from 'rxjs';
// import { ErrorObservable } from 'rxjs';
// 

import { FileUploaderService } from '../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from '../../../../services/global-functions.service';
import { JobReportSubject } from '../../../../shared/models/jobReportSubject.model';


@Component({
  selector: 'app-docx-in-use-check-widget',
  templateUrl: './docx-in-use-check-widget.component.html',
  styleUrls: ['./docx-in-use-check-widget.component.scss']
})
export class DocxInUseCheckWidgetComponent implements OnInit {

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

@Input() doc_template_file?
@Input() document_base_theme_docx?


  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  templateFilesInUse: any;
  temmplateFilesInUseCount: any;
  wrapSettings: { wrapMode: string; };
  themeFilesInUse: any;
  themeFilesInUseCount: number;
  themeFilesInUseComTypes: any;
  themeFilesInUseCountComTypes: number;



  
  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) { 

      // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


  }



   // check for changes. to load data.
   ngOnChanges(changes) {
    // if (changes.item_id) {
    //   // deal with asynchronous Observable result
    //   this.job_id = changes.item_id.currentValue;
    //  // test to see if loads undefined better.
    //  // this.job_id = this.item_id;

    //  // stops error on subjects page not having a job id initally
    //  if(this.job_id >= 1){
    //   this.getJob(this.job_id);
    //  }

    //   // :: Not needed to load for side 
    //   if (this.widget_size != 'side'){
    //   this.getJobPlaintiffs(this.job_id); 
    //   this.getJobReportSubjects(this.job_id);
    //   this.getJobSubjectDocumentsByJobID(this.job_id);
    //   }

    // }

    if (changes.doc_template_file) {
      this.doc_template_file = changes.doc_template_file.currentValue;


      setTimeout(() => {  
        console.log("A Simple Pause!"); 
        this.getSubjectTemplateDocsByDocTemplateFile(this.doc_template_file);
        console.log("Now Ready to load...");
    }, 4000);
    }

    if (changes.document_base_theme_docx) {
      this.document_base_theme_docx = changes.document_base_theme_docx.currentValue;


      setTimeout(() => {  
        console.log("A Simple Pause!"); 
        this.getSubjectTemplateDocsByDocThemeFile(this.document_base_theme_docx);
        this.getSubjectComTypesByDocThemeFile(this.document_base_theme_docx);
        console.log("Now Ready to load...");
    }, 4000);
    }
    
  }


  ngOnInit(): void {
  }


  getSubjectTemplateDocsByDocTemplateFile(doc_template_file) {
    this._demoService.getSubjectTemplateDocsByDocTemplateFile(doc_template_file).subscribe(
       data => {
         this.templateFilesInUse = data;
         let res = data[0];

         const newArr = Object(data).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
        const  count_of_items = Object.keys(newArr).length;

         this.temmplateFilesInUseCount = count_of_items;
        
        },
       err => {
       // this.doc_template_file = '';
        console.log(err.error)
      },
       // () => console.log('done loading Trace Types')
     );
   }



   getSubjectTemplateDocsByDocThemeFile(doc_template_file) {
    this._demoService.getSubjectTemplateDocsByDocThemeFile(doc_template_file).subscribe(
       data => {
         this.themeFilesInUse = data;
         let res = data[0];

         const newArr = Object(data).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
        const  count_of_items = Object.keys(newArr).length;

         this.themeFilesInUseCount = count_of_items;
        
        },
       err => {
       // this.doc_template_file = '';
        console.log(err.error)
      },
       // () => console.log('done loading Trace Types')
     );
   }


   


   getSubjectComTypesByDocThemeFile(doc_template_file) {
    this._demoService.getSubjectComTypesByDocThemeFile(doc_template_file).subscribe(
       data => {
         this.themeFilesInUseComTypes = data;
         let res = data[0];

         const newArr = Object(data).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
        const  count_of_items = Object.keys(newArr).length;

         this.themeFilesInUseCountComTypes = count_of_items;
        
        },
       err => {
       // this.doc_template_file = '';
        console.log(err)
      },
       // () => console.log('done loading Trace Types')
     );
   }



}
